<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">نقشه های راه پیش فرض</h1>
          <p v-for="item in defaultRoadmaps">
            {{ item.Lessons }}
          </p>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetDefaultRoadmaps } from "@/libs/Api/Roadmap";
export default {
  mounted() {
    this.getAllRoadmaps();
  },
  data() {
    return {
      isLoading: false,
      defaultRoadmaps: null,
    };
  },
  methods: {
    async getAllRoadmaps() {
      try {
        this.isLoading = true;
        let _this = this;
        let getDefaultRoadmaps = new GetDefaultRoadmaps(_this);
        await getDefaultRoadmaps.fetch((response) => {
          if (response.isSuccess) {
            _this.defaultRoadmaps = response.data;
            console.log(_this.defaultRoadmaps);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
